import "./instance-settings.less";

import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from './instance-settings.service';
import { dashboardComponent } from './../dashboard/dashboard.component';
import { USERS_SERVICE, UsersService } from "./../users/users.service";
import { IComponentOptions, IComponentController, IOnChangesObject } from "angular";
import { IInstanceSettings } from "../../typings/board/Models";

export const INSTANCE_SETTINGS_COMPONENT = "instanceSettings";

class InstanceSettingsComponentController implements IComponentController {
    private settings: IInstanceSettings;

    private wait: boolean;
    private errorMessage: string;

    static $inject = [USERS_SERVICE, INSTANCE_SETTINGS_SERVICE];
    constructor(private usersService: UsersService, private instanceSettings: InstanceSettingsService) { }

    private createFirstUser(password: string, confirm: string) {
        if (password !== confirm) {
            this.errorMessage = "Passwords doesn't match";
            return;
        }

        if (password.length < 6) {
            this.errorMessage = "Password must be at least 6 characters long";
            return;
        }

        this.wait = true;

        this.usersService.createFirstUser(password)
            .then(() => {
                this.settings.initialized = true;
            }, reason => {
                this.errorMessage = "Administrator already exists or server not running";
            })
            .finally(() => { this.wait = false; });
    }
}

export const instanceSettingsComponentOptions: IComponentOptions = {
    controller: InstanceSettingsComponentController,
    template: require("./instance-settings.html"),
    bindings: {
        settings: "<"
    }
};


// WEBPACK FOOTER //
// ./app/instance-settings/instance-settings.component.ts